import { Dialog, DialogContent } from '@superfunnel/ui-core/v2/Dialog';

import Editor from '@/components/Editor/Editor';
import { AgentRunAttachment } from '@superfunnel/types';

interface NewEditorModalProps {
  dynamicPageId: string;
  initialVariantId: string;
  initialWebsiteId: string;
  initialMessage?:
    | string
    | { content: string; attachments?: AgentRunAttachment[] };
  initialShowAnalytics?: boolean;
  open?: boolean;
  onClose?: () => void;
}

export default function NewEditorModal({
  dynamicPageId,
  initialVariantId,
  initialWebsiteId,
  initialMessage,
  initialShowAnalytics,
  open,
  onClose,
}: NewEditorModalProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="h-screen w-screen max-w-none rounded-none bg-gray-50 p-0"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        {open && (
          <Editor
            mode="website"
            dynamicPageId={dynamicPageId}
            initialVariantId={initialVariantId}
            initialWebsiteId={initialWebsiteId}
            initialMessage={initialMessage}
            initialShowAnalytics={initialShowAnalytics}
            onClose={() => onClose?.()}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
